import { Grid, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { basic, validationMessages } from '../../../config/validations';
import { toggleRightDrawer, setFocusElement, setReRender } from '../../../store/global/actions';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import {IconSelector} from "../../atoms/IconSelectorV2";
import { invokeGetService, invokePostService } from '../../../store/global/actions'
import { findIconSource, formatFetchedCustomIcons, generateIconFileName } from '../../../utils/commonUtils';
import { getterForSensorName } from '../../../config/common';


export default function EditSensor(props) {
    const { element, onCompletion, onClose } = props;
    const dispatch = useDispatch();
    const [sensor, setSensor] = useState(element);
    const [prevIconName, setPrevIconName] = useState("");
    const [icon, setIcon] = useState(null);
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, formState: { errors }, setError, reset, watch } = useForm({
        defaultValues: {
            name: sensor?.name,
            description: sensor?.desc
        }
    });

    const nameValue = watch("name");

    useEffect(() => {
        dispatch(invokeGetService('getClusterlet', [element.id])).then(res => {
           if(res?.status == true){
            setSensor(res?.data);
            setIcon(formatFetchedCustomIcons(res?.data));
            setPrevIconName(res?.data?.icon);
            reset({
                name: res?.data?.name,
                description: res?.data?.attributes?.desc
            });
           } else {
            if (res?.code === 255) {
                dispatch(toggleRightDrawer());
                dispatch(setReRender());
                dispatch(setFocusElement({}));
            }
           }
        });
    }, [])

    const cancelUpdation = () => {
        dispatch(toggleRightDrawer())
    }

    const onUpdate = ({ name, description }) => {
        const updatedSensorInfo = {
            name,
            attributes: {
                ...sensor.attributes,
                desc: description
            },
            type: sensor.type
        }

        if(prevIconName != generateIconFileName(icon)){
            updatedSensorInfo.icon =  generateIconFileName(icon);
            updatedSensorInfo.iconSource =  findIconSource(icon);
        }

        setLoading(true);
        dispatch(invokePostService('editClusterlet', {clusterlet: updatedSensorInfo}, [element.id])).then(res => { 
			setLoading(false);
			if (res?.status === true) {
                if(sensor.name !== name) {
                    dispatch(setFocusElement({ id: sensor._id, type: 'sensor', templateId: '', name: name, icon: sensor?.icon, desc: sensor?.attributes?.desc }));
                }
                onCompletion(getterForSensorName(), 'edit')
			} else {
                if (res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, {message: error.message});
                    });
                }
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
		});
    }

    const messages = { ...validationMessages, validate: 'This name is already used' };



    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    variant="outlined"
                    placeholder={"Name"}
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="description"
                    type={"text"}
                    fullWidth
                    multiline
                    rows={2}
                    maxRows={2}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false })}
                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", marginBottom: 20 }}>
                <IconSelector setSelectedIcon={setIcon} selectedIcon={icon} defaultSearchTag={nameValue}/>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <UpdateCancel updateDisable={loading} content={loading ? 'Updating..' : 'Update'} onUpdate={handleSubmit(onUpdate)} onCancel={cancelUpdation} typesNotIn={['transaction', 'view']}/>
            </Grid>

        </Grid>

    )
}